import { apiInterfaceForJson } from '../common/apiManager';

export const resolveFormDefinition = (params) => {
    return apiInterfaceForJson('/formDefinition/v1/resolve', 'POST', params);
};

export const getAllFormDefinitions = () => {
    return apiInterfaceForJson('/formDefinition/v1/', 'GET');
};

export const getFormDefinitionById = (id) => {
    return apiInterfaceForJson('/formDefinition/v1/' + id, 'GET');
};

export const createFormDefinition = (formDef) => {
    return apiInterfaceForJson('/formDefinition/v1/', 'POST', formDef);
};

export const updateFormDefinition = (formDef) => {
    return apiInterfaceForJson('/formDefinition/v1/', 'PUT', formDef);
};

export const deleteFormDefinition = (formDef) => {
    return apiInterfaceForJson('/formDefinition/v1/delete', 'POST', formDef);
};

export const publishFormDefinition = (formDef) => {
    return apiInterfaceForJson('/formDefinition/v1/publish', 'POST', formDef);
};

export const duplicateFormDefinition = (formDef) => {
    return apiInterfaceForJson('/formDefinition/v1/duplicate', 'POST', formDef);
};
